import {useAuth} from "./AuthContext";
import React, {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import { TRANSACTION_RECEIPT_EVENT } from "../lib/transactionReceipt";
import { useDesign } from "./DesignContext";

const TransactionContext = createContext(null);

const receiptFingerprint = (value = {}) => {
    const raw = value?.raw || value || {};
    return [
        value?.reference || value?.id || raw?.reference || raw?.id || "",
        value?.service || raw?.service || raw?.serviceName || "",
        value?.status || raw?.status || "",
        value?.amount ?? raw?.amount ?? "",
    ].map((item) => String(item ?? "").trim()).join("|");
};

export function TransactionProvider({ children }) {
    const { design } = useDesign();
    const {role,user}=useAuth();
    const [receipt, setReceipt] = useState(null);
    const lastReceiptRef = useRef({ fingerprint: "", at: 0 });

    useEffect(()=>{setReceipt(null);lastReceiptRef.current={fingerprint:'',at:0};},[role,user?.id]);

    const openTransactionReceipt = useCallback((transaction) => {
        if (!transaction) return;

        const fingerprint = receiptFingerprint(transaction);
        const now = Date.now();
        const last = lastReceiptRef.current;

        // Evite yon menm API repons louvri resi a 2 fwa lè yon paj rele
        // openTransactionReceipt() epi interceptor global la emèt menm resi a tou.
        if (fingerprint && fingerprint === last.fingerprint && now - last.at < 1200) {
            return;
        }

        lastReceiptRef.current = { fingerprint, at: now };
        setReceipt({
            ...transaction,
            receiptTemplateUsed:
                transaction?.receiptTemplateUsed ||
                design?.receipts?.activeTemplate ||
                "RECEIPT_01",
        });
    }, [design?.receipts?.activeTemplate]);

    const closeTransactionReceipt = useCallback(() => {
        setReceipt(null);
    }, []);

    useEffect(() => {
        const onOfficialReceipt = (event) => {
            if (!event?.detail) return;
            const partner = String(role).toLowerCase() === 'partner';
            const path = event.detail.sourceUrl || '';
            if (!partner && /\/(recarga\/purchase|nowpayments\/operations|p2p-whatsapp\/partner\/requests)$/.test(path)) return;
            if (!partner && design?.receipts?.autoOpen === false) return;
            openTransactionReceipt(event.detail);
        };

        window.addEventListener(TRANSACTION_RECEIPT_EVENT, onOfficialReceipt);
        return () => window.removeEventListener(TRANSACTION_RECEIPT_EVENT, onOfficialReceipt);
    }, [openTransactionReceipt, design?.receipts?.autoOpen, role]);

    const value = useMemo(
        () => ({ receipt, openTransactionReceipt, closeTransactionReceipt }),
        [receipt, openTransactionReceipt, closeTransactionReceipt]
    );

    return (
        <TransactionContext.Provider value={value}>
            {children}
        </TransactionContext.Provider>
    );
}

export function useTransactionReceipt() {
    const context = useContext(TransactionContext);
    if (!context) {
        throw new Error("useTransactionReceipt must be used inside TransactionProvider");
    }
    return context;
}

export default TransactionContext;
